module.exports = __webpack_public_path__ + "static/media/background-10.c1707354.jpg";